/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PersonIcon from './ic_action_person.png';
import App from '../App/App';
import './Menu.css';

/**
 * Represents the menu component that apperars on the left side.
 */

 export default class Menu extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        context:            PropTypes.object.isRequired
    }

    /**
     * Gets the menu style.
     * 
     * @return  {Object}    style   style of the menu.
     */

    getMenuStyle() {

        // Width of the menu

        const WIDTH = 240;

        // Returning the menu style

        return {
            width:      WIDTH + 'px',
            height:     this.props.context.environment.browser.info.mobile ? '100%' : 
                        (this.props.context.environment.screen.usefullheight + 'px'),
            top:        (this.props.context.environment.screen.height - 1 -
                        this.props.context.environment.screen.usefullheight) + 'px',
            transform:  'translateX(' + (this.props.visible ? '0px' : 
                        ((this.props.context.environment.browser.info.type === App.BROWSER.EDGE ? 
                        this.props.context.environment.screen.zoom : 1) * (-1 * (WIDTH + 4))) + 'px') + ')' 
        };
    }
       
    /** 
     * Menu renderer.
     */

    render() {
        return (
            <div className="menu vertical" style={this.getMenuStyle()} onClick={(event) => {event.stopPropagation();}}>

                {/* User information */}

                { this.props.context.user &&
                    <div className="menu-userinfo horizontal">
                        <img alt="Person" src={PersonIcon} className="menu-accounticon"></img>
                        <div className="vertical" style={{ paddingTop: this.props.context.user.email ? 3 : 5 }}>
                            <div className="menu-userinfo-container-name">{ this.props.context.user.name || 'Anonim Felhasználó' }</div>
                            {this.props.context.user.email && <div className="menu-userinfo-container-email">{ this.props.context.user.email}</div>}
                        </div>
                    </div>
                }

                {/* Menu container */}

                <div className="menu-container">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js